import React from 'react'

import ErrorPage, { errorLinks } from './ErrorPage'

const notFoundInfo = {
  code: 404,
  title: 'Página não encontrada',
  body: `
    Ei, esta página não está disponível!
    Separamos alguns links que podem te ajudar:
  `,
  links: errorLinks,
}

export default () => <ErrorPage {...notFoundInfo} />
